var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityStorageRoom = function SvgFacilityStorageRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-40v-880h60v80h600v-80h60v880h-60v-80H180v80zm60-469h110v-160h220v160h270v-271H180zm0 329h270v-160h220v160h110v-269H180zm170-329h100v-100H350zm160 329h100v-100H510zM350-509h100zm160 329h100z"
  })));
};
export default SvgFacilityStorageRoom;